import type {LatLngTuple} from "leaflet";

export const INITIAL_POSITION: LatLngTuple = [54.5040959, 18.5492281];
export const MAP_OVERLAY = 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=e87fd70e-89e4-43ef-8d2a-2b12df2d984'
export const MAP_ZOOM = {
    default: 15,
    min: 5,
    max: 17
};
